module.exports = __webpack_public_path__ + "img/4b7fe493cca8e08260d35ec38c0a2412.png";